<template>
  <div class="">
    <div class="label-standard">
      <RequiredAsterisk v-if="required"></RequiredAsterisk>
      BSB
    </div>

    <div class="form-line relative">
      <input type="text" 
        class="input-standard"
        :value="value"
        ref="value"
        v-on:keyup="formatBSB($event.target.value)"
        v-on:blur="updateValue({
          key     : propertyKey,
          value   : $event.target.value,
          index   : index,
          objectId: objectId
        }); bsbUpdated($event.target.value);" />

      <div v-if="!bankLoading && bank != null && bank.image != null"
        style="position:absolute;top:7px;right:6px;"
        class="text-gray-700">
        <img :src="'/static/img/banks/' + bank.image" style="height:28px;" />
      </div>
      <div v-if="bankLoading" 
        style="position:absolute;top:13px;right:10px;">
        <img src="/static/img/ajax-loader.gif" style="height:8px;" />
      </div>
    </div>

    <div v-if="!bankLoading" class="mt-2 mr-1 text-gray-900 text-right text-xs">
      {{ bank != null ? bank.name : '' }}
    </div>
  </div>
</template>

<script>
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    components : {
      RequiredAsterisk
    },

    props : {

      objectId : {
        type : Number,
        required : false
      },

      label : {
        type    : String,
        required: false
      },

      subLabel : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },
      
      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      bankProp : {
        type    : Object,
        required: false
      },

      required : {
        type : Boolean,
        required : false
      }

    },

    data() {
      return {
        bankLoading: false,
        bank       : this.bankProp
      }
    },

    methods : {

      bsbUpdated(value) {
        // console.log(value)

        // note that when the key is BSB, we want to fetch the 
        // bank information from the database
        // for SAVINGS, BSB is stored in column string1, so that's what we should look at
        // Once we receive the bank information, let's assign the value to the object
        // so it gets displayed immediately
        if(value.length > 0) {
          this.bankLoading = true
          this.apiGet({
            bsb : value,
          }, 'common/bank-information', (bank) => {
            this.bankLoading = false
            this.bank        = bank       
          })
        }

        else {
          this.bank = null
        }
      },

      formatBSB(value) {

        if(value.length > 3) {
          value = value.substring(0, 3) + ' ' + value.substring(3).trim()
        }

        this.$refs.value.value = value
      },
    }
  }
</script>